import React, { Component } from 'react';
import classnames from 'classnames';
import ReactDOM from 'react-dom';
import { Route, Router } from 'react-router';
import { Provider, connect } from 'react-redux';
import PropTypes from 'prop-types';
import createStoreAndRunSagas from '../../modules/createStoreAndRunSagas';
import DeleteNotification from '../components/DeleteNotification';

@connect((state) => ({ notifications: state.profileModule.notifications }))
class Sidebar extends Component {
  render() {
    return (
      <div>
        {this.props.notifications.map((notification) => (
          <div key={`not${notification.notificationId}`} className={classnames([`not-${notification.notificationId}`])}>
            <DeleteNotification {...notification} />
          </div>
        ))}
      </div>
    );
  }
}

Sidebar.propTypes = { notifications: PropTypes.arrayOf(PropTypes.object) };

function initializeWidgets() {
  const store = createStoreAndRunSagas();

  const { history } = document;
  if (!document.history) document.history = history;

  ReactDOM.render(
    <Provider store={store}>
      <Router history={history}>
        <Route path="my-resources*" component={Sidebar}></Route>
      </Router>
    </Provider>,
    window.document.getElementById('app-widgets'),
  );
}

document.addEventListener('DOMContentLoaded', initializeWidgets);
